import { render, staticRenderFns } from "./purchaseReturnStat.vue?vue&type=template&id=4d6ba104&scoped=true&"
import script from "./purchaseReturnStat.vue?vue&type=script&lang=js&"
export * from "./purchaseReturnStat.vue?vue&type=script&lang=js&"
import style0 from "./purchaseReturnStat.vue?vue&type=style&index=0&lang=less&"
import style1 from "./purchaseReturnStat.vue?vue&type=style&index=1&id=4d6ba104&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6ba104",
  null
  
)

component.options.__file = "purchaseReturnStat.vue"
export default component.exports